import { Fqdn } from '../model';

const FQDN_REGEX = /^wix\.(.+)\.(v\d+)\.(.+)$/;

export function parseFqdn(fqdnString: string): Fqdn {
  const result = fqdnString.match(FQDN_REGEX);

  if (result == null) {
    return {
      product: fqdnString,
    };
  }

  const [, domainAndProduct, version, resource] = result;

  const [product, domain] = domainAndProduct?.split('.')?.reverse() ?? [];

  return {
    domain,
    product,
    resource,
    version,
  };
}

export function fqdnToString(fqdn: Fqdn): string {
  return [
    'wix',
    ...[fqdn.domain, fqdn.product, fqdn.version, fqdn.resource].filter(Boolean),
  ].join('.');
}

export function isFqdnValid(fqdn: Fqdn): boolean {
  return fqdn.resource !== undefined;
}
